// Client-side session storage. The app holds the bearer token (no supabase-js
// session); it is sent to edge functions on each authenticated call.

const KEY = "rt.session";

export interface StoredSession {
  access_token: string;
  refresh_token: string;
  user_id: string;
}

export function saveSession(session: StoredSession): void {
  localStorage.setItem(KEY, JSON.stringify(session));
}

export function loadSession(): StoredSession | null {
  const raw = localStorage.getItem(KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as StoredSession;
  } catch {
    return null;
  }
}

export function clearSession(): void {
  localStorage.removeItem(KEY);
}
